import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/home1.jpg';
import { Helmet } from 'react-helmet';

const About2 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
         <>
      <Helmet>
        <title>About Us - Yatri Interiors</title>
        <meta name="description" content="Crafting Interiors with Precision and Passion" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                           {/*** <div className="about-left-text">
                                <img src={About3} alt="" />
                                <h5>SINCE</h5>
                                <span>1998</span>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <h2>Crafting Interiors with Precision and Passion</h2>
                                <p>At YATRI INTERIORS, we believe that every space tells a story — of dreams, utility, and identity. Founded with the vision to bring creative interior design and robust execution under one roof,
                                 our Bengaluru-based team delivers high-quality,
                                  functional, and aesthetically pleasing interiors for
                                   homes, offices, and commercial establishments.
We’re not just designers — we are problem-solvers,space optimizers, and quality enablers.
 Backed by experienced professionals
  across design, electricals, carpentry,
   plumbing, and painting, we bring a complete 
   interior experience from concept to completion..
                                </p>
                                {/***<ul>
                                    <li>Where To Invest In Real Estate.</li>
                                    <li>7 Pieces Of Advice To Newbies.</li>
                                    <li>OCutting Your Losses In Real Estate.</li>
                                    <li>50% Off All Organic Product</li>
                                </ul> */}
                                <Link onClick={ClickHandler} to='/contact' className="theme-btn">CONTACT US</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
        
    )
}

export default About2;